import {generateNodeStyle, strokeWidthOfLine} from '../../components/molecules/bluePrintComponents/SystemModel/generateStyle';
import {
    nodeCountStart,
    nodeKeysLabel,
    constructIds,
    internalSystem,
    blueprintHeight,
    blueprintWidth,
    xCordLeftMargin,
    yCordTopMargin,
    w,
    h,
    aiNodes,
    gapBtwRightBorderAndInternalNode,
    gapBTWRightBorderAndExternalNode,
    gapBTWLeftBorderAndExternalNode,
    internalSystemNodes,
    externalSystemNodes,
    internalSystemNodesTypes,
    externalSystemNodeTypes,
} from '../../config/common';
import { generateMongoId } from '../../utils/commonUtils';

const shortUUid = require('short-uuid');

const getId = (type, id) => `${id}`;

const isAnimatedTrue = (params) => {
    const source = params?.source?.split('-').includes('profile');
    const target = params?.target?.split('-').includes('clusterlet');
    if (source && target) return true;
    return false;
};

const getStrokeWidthLine = (params) => {
    if (isAnimatedTrue(params)) return 2;
    return strokeWidthOfLine;
};

const generateNewNode = (element, delegateProtocols) => {
    const {position, name, id} = element;
    let type = element.type;
    type = constructIds.find((i) => i.id === type).type;

    //overwrite if its a controller_delegate
    type = element?.subType == 'controller' ? 'controller_delegate' : type;

    const converted = {
        id: getId(type, id),
        type,
        position,
        sourcePosition: 'right',
        targetPosition: 'left',
        data: {label: name, icon: element?.icon, desc: element?.attributes?.desc, profile: element?.profile?.length > 0 ? true : false, isCustomIcon: element?.isCustomIcon ? true : false, iconSource: element?.iconSource, helperText: element?.helperText, provenance: element?.provenance },
        ...(generateNodeStyle(type) || {}),
    };

    if (element?.attributes?.type !== undefined && !aiNodes.includes(element?.attributes?.type)) {
        console.log(element, 'modifi elem')
        const delegateNode = delegateProtocols.find((item) => item.node == element?.attributes?.type);
        if ((delegateNode && delegateNode.schemaJson && delegateNode.schemaJson.desc) || (type === "external_function")) {
            converted.data.protocolDesc = delegateNode?.schemaJson?.desc || element.attributes?.protocol || element.attributes?.type?.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
        }
        converted.data.protocol = element?.attributes?.type;
    }

    if (element?.attributes?.type !== undefined && aiNodes.includes(element?.attributes?.type)) {
        converted.data.subType = element?.attributes?.type;
    }

    if (element.templateId) {
        converted.templateId = element.templateId;
    }

    return converted;
};

const generateNewNodeEdge = (params) => {
    return {
        ...params,
        animated: isAnimatedTrue(params),
        style: {
            strokeWidth: getStrokeWidthLine(params),
        },
    };
};

function mapType(llmType) {
    if(llmType.toLowerCase().includes("delegate") && !llmType.toLowerCase().includes("controller")){
        return 'delegate'
    }
    switch (llmType.toLowerCase()) {
        case 'sensor':
            return 'sensor';
        case 'digital twin':
            return 'digital_twin';
        case 'controller delegate':
        case 'controller_delegate':
            return 'controller_delegate';
        case 'enterprise app':
        case 'enterprise_app':
            return 'enterprise_app';
        case 'infer engine':
        case 'learn engine':
        case 'generate engine':
            return llmType.toLowerCase()
        default:
            return 'clusterlet';
    }
}

export function createNode(item, parentId) {
    const baseStyle = {
        padding: 4,
        borderRadius: 2,
        marginBottom: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'grab',
    };

    let nodeType = mapType(item.type.toLowerCase()); // default
    let style = {...baseStyle, width: 150, height: 50, border: '1px solid #000', backgroundColor: '#fff'};
    let data = {label: item.name, desc: item.description, type: item.type};
    
    const typeLower = mapType(item.type.toLowerCase());
    const exactType = item.type.toLowerCase()
    if(exactType.includes('http')){
        data.type = "http_delegate"
    }else if(exactType.includes('mysql')){
        data.type = "mysql_delegate"
    }else if(exactType.includes('cv')){
        data.type = "cv_delegate"
    }else if(exactType.includes('controller') && exactType.includes('delegate')){
        data.type = "controller_delegate"
    }else if((exactType.includes('delegate') || exactType.includes('app bridge'))){
        data.type = "http_delegate"
    }
    
    if (typeLower.includes('delegate') && !typeLower.includes('controller')) {
        nodeType = 'external_function';
        style = {
            ...baseStyle,
            width: 120,
            height: 120,
            background: 'url(/node_icons/ide_delegate.png) 50% 50% / 108px 108px no-repeat',
            border: 'none',
        };
        data.icon = "/node_icons/ide_delegate.png"
    } else if (typeLower === 'sensor' || typeLower === 'enterprise_app') {
        nodeType = typeLower === 'enterprise_app' ? 'user' : 'sensor';
        style = {
            ...baseStyle,
            width: 100,
            height: 90,
            background: 'url(/node_icons/ide_sensor.png) 50% 50% / 90px 90px no-repeat',
            color: '#fff',
            border: 'none',
        };
        data.icon = "ide_sensor_default"
    } else if (typeLower === 'digital_twin' || typeLower === 'clusterlet' || ["clusterlet", "digital_twin", "infer engine", "learn engine", "generate engine"].includes(typeLower)) {
        nodeType = typeLower === "digital_twin" ? "clusterlet" : typeLower === 'clusterlet' ? 'analytics' : typeLower.replace(/\s+/g, "_");
        style = {
            ...baseStyle,
            width: 90,
            height: 83,
            background: 'url(/node_icons/digitaltwin_sd.png) 50% 50% / 90px 83px no-repeat',
        };
        data.icon = 'ide_analytics_default'
    } else if (typeLower === 'controller delegate') {
        nodeType = 'controller_delegate';
        style = {
            ...baseStyle,
            width: 150,
            height: 50,
            backgroundColor: '#fff',
            border: '1px solid #666',
        };
        data.profile = false;
        data.isCustomIcon = false;
        data.protocol = 'http_delegate';
    }

    data.desc = item.type;

    let position = {x: 0, y: 0}
    return {
        type: nodeType,
        data: {label: item.name, desc: item.type, ...data},
        position,
        parentNode: nodeType !== "external_function"  && !nodeType.includes("delegate") && nodeType !== "sensor" && nodeType !== "user" ? parentId : null,
        extent: nodeType !== "external_function"  && !nodeType.includes("delegate") && nodeType !== "sensor" && nodeType !== "user" ? 'parent' : undefined,
        style,
    };
}


export const rfNodesToNode = (rfNodes) => {
    const nodes = [];

    rfNodes.forEach((node) => {
        if(node.id !== "A" && node.id !== "labelNode" && node.data.label !== "controller_delegate"){
            const structure = {}
            const attributes = {
                desc: node.data.desc,
                type: node.data.type
            }
            structure.type = constructIds.find(item => item.type === node.type).id;
            structure.position = findRelativePosition(node.position, structure.type)
            if(internalSystemNodesTypes.includes(structure.type) || externalSystemNodeTypes.includes(structure.type)){
                structure.icon = node.data.icon
                delete attributes.type
            }
            structure._id = node.id

            nodes.push({
                name: node.data.label,
                ...structure,
                attributes
            })
        }else if(node.id === "A"){
            node.position = findRelativePosition(node.position, node.type)
            node.dimension = findRelativeDimension(node.style)
            nodes.push(node)
        }
    })

    return nodes;
}

export const convertLLMtoReactFlow = (
    structure,
    parentId = 'A',
    internalSystem,
    labelNode,
    controller
  ) => {
    const rfNodes = [];
    const rfEdges = [];
    // map: name -> { id, node }
    const seen = new Map();
    let edgeCount = 0;
    // ----- PASS 1: create nodes for all unique names -----
    structure.forEach((chain) => {
      chain.forEach((item) => {
        if (!seen.has(item.name)) {
            let nodeId = generateMongoId();
            if(item.type.toLowerCase().includes('controller') && item.type.toLowerCase().includes('delegate')){
                nodeId = controller.id
            }
            const node = createNode(item, parentId);
            // ensure the generated id is used (overwrite any id createNode may have set)
            const nodeWithId = { ...node, id: nodeId };
            seen.set(item.name, { id: nodeId, node: nodeWithId });
            rfNodes.push(nodeWithId);
        }
      });
    });
  
    // add internal system node (keep parentId if internalSystem has no id)
    const internalSystemNode = { ...internalSystem, id: internalSystem.id || parentId };
    rfNodes.push(internalSystemNode, labelNode);
  
    // ----- PASS 2: create edges using IDs from `seen` -----
    structure.forEach((chain) => {
      for (let i = 0; i < chain.length - 1; i++) {
        edgeCount++;
        const sourceItem = chain[i];
        const targetItem = chain[i + 1];
  
        const sourceEntry = seen.get(sourceItem.name);
        const targetEntry = seen.get(targetItem.name);
  
        // defensive check (shouldn't happen because of pass 1)
        if (!sourceEntry || !targetEntry) continue;
  
        const sourceType = mapType(sourceItem.type);
        const targetType = mapType(targetItem.type);
  
        let sourcePort;
        let targetPort;
        if (sourceType === 'delegate' || targetType === 'delegate') {
          if (sourceType === 'delegate') {
            if (['user', 'sensor'].includes(targetType)) {
              sourcePort = 'left';
              targetPort = 'right';
            } else {
              sourcePort = 'right';
              targetPort = 'left';
            }
          } else if (targetType === 'delegate') {
            if (['user', 'sensor'].includes(sourceType)) {
              sourcePort = 'right';
              targetPort = 'left';
            } else {
              sourcePort = 'left';
              targetPort = 'right';
            }
          }
        }
  
        const edge = {
          id: generateMongoId(), // use Mongo-style id for edges too (optional)
          source: sourceEntry.id,
          target: targetEntry.id,
        };
  
        if (sourcePort) edge.sourceHandle = sourcePort;
        if (targetPort) edge.targetHandle = targetPort;
  
        rfEdges.push(edge);
      }
    });
  
    return {
      nodes: rfNodes.sort((a, b) => {
        if (a.id === parentId) return -1;
        if (b.id === parentId) return 1;
        return 0;
      }),
      edges: rfEdges,
    };
};

export const readjustEdges = (nodes, edges) => {
    return edges.map(edge => {
      const source = nodes.find(node => node.id === edge.source);
      const target = nodes.find(node => node.id === edge.target);
  
      const dx = target.position.x - source.position.x;
      console.log({dx, source, target},'edges dx')
      
      if (!source || !target || (source.parentNode !== "A" && source.type !== "controller_delegate") || (target.parentNode !== "A" && target.type !== "controller_delegate")) return edge;
  
      let sourceHandle = 'right';
      let targetHandle = 'left';
  

      // Horizontal connection
      if (dx > 0) {
        sourceHandle = 'right';
        targetHandle = 'left';
      } else {
        sourceHandle = 'left';
        targetHandle = 'right';
      }
  
      return {
        ...edge,
        sourceHandle,
        targetHandle,
      };
    });
};

export const countOfClusterlet = (type, clusterletsInStore) => {

    let clusterletCount = 0;
    let nextCount = 0;
    let countMax = 0;

    clusterletCount = clusterletsInStore.length;

    if (clusterletCount === 0) {
        nextCount = nodeCountStart[type] + 1;
    } else {
        //add the count after checking the max extension number provided in the ids of elements
        //add one to the max extension number
        const idOfClusterletAdded = constructIds.find((e) => e.type === type).id;
        const numberOfElements = clusterletsInStore.filter((e) => e.type === idOfClusterletAdded).length;

        const uuids = clusterletsInStore.filter((e) => e.type === idOfClusterletAdded).map((e) => e.id);
        const uuidsExtensionNumbers = uuids
            .map((uuid) => {
                const extNo = uuid.split('-');
                return extNo[1];
            })
            .filter((i) => i);

        if (uuidsExtensionNumbers.length) {
            countMax = Math.max(...uuidsExtensionNumbers);
            nextCount = countMax + 1;
        } else {
            nextCount = nodeCountStart[type] + numberOfElements + 1;
        }
    }
    return nextCount;
};

export const countOfElement = (elements, splitWord) => {
    let elementCount = 0;
    let nextCount = 0;
    let countMax = 0;

    elementCount = elements !== undefined ? elements.length : 0;

    //this is in the case of instances as by default controller delegate instance will be present
    //please modify the fn if you want to reuse according to yr need
    if (elementCount === 1) {
        nextCount = 1;
    } else {
        const names = (elements || []).map((e) => e.name);
        const numbers = names
            .map((uuid) => {
                const extNo = uuid.split(splitWord);
                return extNo[1];
            })
            .filter((i) => i);

        if (numbers.length) {
            countMax = Math.max(...numbers);
            nextCount = countMax + 1;
        }
    }
    return nextCount;
};

export const generateConnection = (data1, data2) => {
    const connectionString = {
        id: shortUUid.generate(),
        source: `${data1.id}`,
        sourceHandle: 'right',
        target: `${data2.id}`,
        targetHandle: 'left',
    };
    return connectionString;
};

export const convert = (clusterlets, clusterletConnections, delegateProtocols) => {

    const systemModelElements = clusterlets.map((element) => {
        return generateNewNode(element, delegateProtocols);
    });

    const systemModelConnections = clusterletConnections?.map((connection) => {
        return generateNewNodeEdge(connection);
    });

    const systemModelData = [...systemModelElements, ...systemModelConnections];
    return systemModelData;
};

export const toClusterletData = (type, position, clusterletsInStore, elements, event) => {
    const nextCount = countOfClusterlet(type, clusterletsInStore);

    let attributes = {};
    let defaultType = 'http2_delegate';

    switch (type) {
        case 'external_function':
            attributes = {type: defaultType};
            break;
        case 'clusterlet':
        case 'analytics':
            attributes = {parent: 'controller'};
            break;

        case 'infer_engine':
            attributes = {parent: 'controller'};
            break;
        case 'learn_engine':
            attributes = {parent: 'controller'};
            break;
        case 'generate_engine':
            attributes = {parent: 'controller'};
            break;
        default:
            break;
    }

    let newPosition = setPosition(type, elements, position, event);

    const clusterlet = {
        name: `${nodeKeysLabel[type]}${nextCount}`,
        id: shortUUid.generate() + `-${nextCount}`,
        type: constructIds.find((x) => x.type === type).id,
        position: newPosition,
        attributes: attributes,
        // data: { highlighter: true }
    };

    if (['infer_engine', 'learn_engine', 'generate_engine'].includes(type)) {
        clusterlet.attributes.type = type;
    }

    // console.log({clusterlet})

    return clusterlet;
};

export const toTemplateClueterletData = (type, position, templateInStore, elements, event) => {
    const nextCount = countOfClusterlet(type, templateInStore);

    let newPosition = setPosition(type, elements, position, event);

    const template = {
        id: shortUUid.generate() + `-${nextCount}`,
        type: constructIds.find((x) => x.type === type).id,
        position: newPosition,
        // attributes: attributes,
        // data: { highlighter: true }
    };

    return template;
};

const setPosition = (type, elements, position, event) => {
    if (type == 'analytics' || type == 'infer_engine' || type == 'learn_engine' || type == 'generate_engine') {
        return getSystemInsidePosition(elements, event, position);
    } else if (type == 'external_function') {
        return delegatePosition(position, 'drop');
    } else if (type == 'clusterlet' || type == 'templated_clusterlet') {
        return getSystemInsidePosition(elements, event, position);
    } else {
        return sesnorUserPosition(position, 'drop');
    }
};

const getSystemInsidePosition = (elements, event, position) => {
    const positionX = position.x - internalSystem.position.x;
    const positionY = position.y - internalSystem.position.y;
    const positions = clusterletPosition({x: positionX, y: positionY}, 'drop');
    return positions;
};

export const profileData = (type, selectedClusterlet, clusterletsInStore) => {
    const nextCount = countOfClusterlet(type, clusterletsInStore);

    let clusterletName = selectedClusterlet?.name.charAt(0).toUpperCase() + selectedClusterlet?.name.slice(1);

    const profile = {
        name: `${selectedClusterlet.name}_Profile`,
        id: shortUUid.generate() + `-${nextCount}`,
        type: constructIds.find((x) => x.type === type).id,
        position: {x: selectedClusterlet.position.x + 300, y: selectedClusterlet.position.y},
        attributes: {userconfig: true, parent: 'controller', collection: true, desc: ` Configuration for clusterlet ${clusterletName}`},
    };

    return profile;
};

export const addProfileIdToClusterlet = (clusterletId, profileId, clusterletsInStore) => {
    //console.log({ clusterletId, profileId, clusterletsInStore })

    const index = clusterletsInStore.findIndex((e) => e.id === clusterletId);
    //console.log("index", index)

    clusterletsInStore[index].profile ? clusterletsInStore[index].profile.push({id: profileId}) : (clusterletsInStore[index].profile = [{id: profileId}]);

    const editedElement = clusterletsInStore[index];

    const payload = editedElement;

    return payload;
};

export const toInstanceData = (clusterlet, instances) => {
    // let instanceName = 'local'
    // const number = countOfElement(instances, 'local')
    // instanceName = `${instanceName}${number}`

    let instanceName = clusterlet.name;

    const instanceData = {
        name: clusterlet.type === 1 ? instanceName /*clusterlet.attributes.network*/ : 'default',
        type: constructIds.find((x) => x.type === 'instance').id,
        attributes: {
            type: clusterlet.id,
        },
    };

    if (clusterlet?.attributes?.network) {
        instanceData.attributes.networks = [clusterlet.attributes.network];
    }

    /**if delegate:-
     * add scope and runtime to attributes
     * */
    if (clusterlet.type === 1) {
        instanceData.attributes.scope = 'runtime';
        instanceData.attributes.monitor = true;
    }

    return instanceData;
};

export const internalSystemConfig = () => {
    const startPosX = JSON.parse(JSON.stringify(internalSystem.position.x));
    const startPosY = JSON.parse(JSON.stringify(internalSystem.position.y));

    const height = JSON.parse(JSON.stringify(internalSystem.style.height));
    const width = JSON.parse(JSON.stringify(internalSystem.style.width));

    return {
        startPosX,
        startPosY,
        height,
        width,
    };
};

const generateNodePosition = (payload) => {
    const {yPositions} = payload;

    const bufferHeight = 125;

    const highestYPos = Math.max(...yPositions);

    return highestYPos + bufferHeight;
};

export const generateDigitalTwinPosition = (payload) => {
    const {startPosX, startPosY, height, width} = internalSystemConfig();

    const {digitalTwins} = payload;

    let newYPos = 0;

    const digitalTwinsAbsolutePositions = digitalTwins.map((item) => {
        const absoluteX = (item.position.x * blueprintWidth) / 100;
        const absoluteY = (item.position.y * blueprintHeight) / 100;

        item.absolutePosition = {x: absoluteX, y: absoluteY};
        return item;
    });

    const digitalTwinsYPositions = digitalTwinsAbsolutePositions.map((item) => item.absolutePosition.y);

    if (digitalTwinsYPositions.length === 0) {
        newYPos = startPosY + height / 4;
    } else newYPos = generateNodePosition({yPositions: digitalTwinsYPositions});

    return {
        x: startPosX + width / 6,
        y: newYPos,
    };
};

export const generateAnalyticsPosition = (payload) => {
    const {startPosX, startPosY, height, width} = internalSystemConfig();

    const {analytics} = payload;

    let newYPos = 0;

    const analyticsAbsolutePositions = analytics.map((item) => {
        const absoluteX = (item.position.x * blueprintWidth) / 100;
        const absoluteY = (item.position.y * blueprintHeight) / 100;

        item.absolutePosition = {x: absoluteX, y: absoluteY};
        return item;
    });

    const analyticsYPositions = analyticsAbsolutePositions.map((item) => item.absolutePosition.y);

    if (analyticsYPositions.length === 0) newYPos = startPosY + height / 4;
    else newYPos = generateNodePosition({yPositions: analyticsYPositions});

    return {
        x: startPosX + width / 2,
        y: newYPos,
    };
};

export const generateSensorPosition = (payload) => {
    const {startPosX, startPosY, height, width} = internalSystemConfig();

    const bufferWidth = 350;

    const {sensors} = payload;

    let newYPos = 0;

    const sensorAbsolutePositions = sensors.map((item) => {
        const absoluteX = (item.position.x * w) / 100;
        const absoluteY = (item.position.y * h) / 100;

        item.absolutePosition = {x: absoluteX, y: absoluteY};
        return item;
    });

    const sensorsYPositions = sensorAbsolutePositions.map((item) => item.absolutePosition.y);

    if (sensorsYPositions.length === 0) newYPos = startPosY + height / 4;
    else newYPos = generateNodePosition({yPositions: sensorsYPositions});

    return {
        x: startPosX - bufferWidth,
        y: newYPos,
    };
};

export const generateUserPosition = (payload) => {
    const {startPosX, startPosY, height, width} = internalSystemConfig();

    const bufferWidth = 350;

    const {users} = payload;

    let newYPos = 0;

    const userAbsolutePositions = users.map((item) => {
        const absoluteX = (item.position.x * w) / 100;
        const absoluteY = (item.position.y * h) / 100;

        item.absolutePosition = {x: absoluteX, y: absoluteY};
        return item;
    });

    const usersYPositions = userAbsolutePositions.map((item) => item.absolutePosition.y);

    if (usersYPositions.length === 0) newYPos = startPosY + height / 4;
    else newYPos = generateNodePosition({yPositions: usersYPositions});

    return {
        // x: startPosX - bufferWidth,
        x: startPosX + ((width + bufferWidth) * 85) / 100,
        y: newYPos,
    };
};

export const generateDelegatePosition = (payload) => {
    const {delegates} = payload;

    const delegateHalfWidth = 98;

    const {startPosX, startPosY, height, width} = internalSystemConfig();

    let newYPos = 0;

    const delegateAbsolutePositions = delegates
        .filter((item) => item.name !== 'Controller')
        .map((item) => {
            const absoluteX = (item.position.x * blueprintWidth) / 100;
            const absoluteY = (item.position.y * blueprintHeight) / 100;

            item.absolutePosition = {x: absoluteX, y: absoluteY};
            return item;
        });

    const delegatesYPositions = delegateAbsolutePositions?.map((item) => item.absolutePosition.y);

    if (delegatesYPositions.length === 0) newYPos = startPosY + height / 10;
    else newYPos = generateNodePosition({yPositions: delegatesYPositions});

    return {
        x: startPosX - delegateHalfWidth,
        y: newYPos,
    };
};

export const generateTemplateClusterletPosition = (payload) => {
    const {startPosX, startPosY, height, width} = internalSystemConfig();

    const {templates} = payload;

    let newYPos = 0;

    const templatesAbsolutePositions = templates.map((item) => {
        const absoluteX = (item.position.x * blueprintWidth) / 100;
        const absoluteY = (item.position.y * blueprintHeight) / 100;

        item.absolutePosition = {x: absoluteX, y: absoluteY};
        return item;
    });

    const templatesYPositions = templatesAbsolutePositions?.map((item) => item.absolutePosition.y);

    if (templatesYPositions.length === 0) {
        newYPos = startPosY + height / 5;
    } else newYPos = generateNodePosition({yPositions: templatesYPositions});

    return {
        x: (startPosX + width) / 12,
        y: newYPos - (height * 15) / 100,
    };
};

export const setCharacterLimit = ({string, limit}) => {
    let newString = string;

    if (string.length > limit) {
        newString = string.substring(0, limit - 5) + `..`;
    }

    return newString;
};

export const findRelativePosition = (position, type) => {
    // console.log("position and type", position, type)

    const x = JSON.parse(JSON.stringify(position.x));
    const y = JSON.parse(JSON.stringify(position.y));

    let relativeX = (x / blueprintWidth) * 100;
    let relativeY = (y / blueprintHeight) * 100;

    //sensor or user relative to screen
    if (type === 4 || type === 20) {
        relativeX = (x / w) * 100;
        relativeY = (y / h) * 100;
    }

    return {
        x: relativeX,
        y: relativeY,
    };
};

export const findAbsolutePosition = (position, type, highestXVal) => {
    // console.log("findAbsolutePosition",{position, type, highestXVal})

    const x = JSON.parse(JSON.stringify(position.x));
    const y = JSON.parse(JSON.stringify(position.y));

    let absoluteX = 0;
    let absoluteY = 0;

    const blueprintRelativeNodes = ['external_function', 'clusterlet', 'analytics', 'templated_clusterlet', 'template_delegate'];

    if (blueprintRelativeNodes.includes(type)) {
        absoluteX = (x * blueprintWidth) / 100;
        absoluteY = (y * blueprintHeight) / 100;
    }

    if (type === 'external_function' || type === 'template_delegate') {
        const positions = delegatePosition({x: absoluteX, y: absoluteY}, 'render', highestXVal);
        absoluteX = positions.x;
        absoluteY = positions.y;
    }

    if (type === 'clusterlet' || type === 'analytics' || type === 'templated_clusterlet') {
        const positions = clusterletPosition({x: absoluteX, y: absoluteY}, 'render');
        absoluteX = positions.x;
        absoluteY = positions.y;
    }

    if (type === 'sensor' || type === 'user') {
        // console.log("sensor and user relative", position)
        const absolutePositionX = (x * w) / 100;
        const absolutePositionY = (y * h) / 100;
        const positions = sesnorUserPosition({x: absolutePositionX, y: absolutePositionY}, 'render', highestXVal);
        absoluteX = positions.x;
        absoluteY = positions.y;
    }

    return {
        x: absoluteX,
        y: absoluteY,
    };
};

export const findAbsoluteDimension = (dimension) => {
    const width = dimension.width;
    const height = dimension.height;

    let absoluteWidth = (width * blueprintWidth) / 100;
    let absoluteHeight = (height * blueprintHeight) / 100;

    return {width: absoluteWidth, height: absoluteHeight};
};

export const findRelativeDimension = function (dimension) {
    const width = dimension.width;
    const height = dimension.height;

    let relativeWidth = (width / blueprintWidth) * 100;
    let relativeHeight = (height / blueprintHeight) * 100;

    return {width: relativeWidth, height: relativeHeight};
};

export const findNodesPositionValidity = (position, type) => {
    // console.log("findNodespostionValidity")

    const x = position.x;
    const y = position.y;

    let absoluteX = 0;
    let absoluteY = 0;

    if (type == 'external_function') {
        return delegatePosition({x: absoluteX, y: absoluteY}, 'render');
    }

    return position;
};

export const delegatePosition = (position, action, highestXVal) => {
    //actions ---> drop, drag, render
    const delegateHalfWidth = 60; //120
    const delegateHalfHieght = 60; //120
    let xRightPos = internalSystem.position.x + internalSystem.style.width - delegateHalfWidth;
    let rightBorder = internalSystem.position.x + internalSystem.style.width;

    if (highestXVal && highestXVal > 0) {
        if (internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode > internalSystem.position.x + internalSystem.style.width) {
            xRightPos = internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode - delegateHalfWidth;
        }
        rightBorder = internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode;
    }

    // const x = position.x < (internalSystem.position.x + (internalSystem.style.width / 2)) ? (internalSystem.position.x - delegateHalfWidth) : (internalSystem.position.x + internalSystem.style.width) - delegateHalfWidth

    // const x = position.x < (internalSystem.position.x + (internalSystem.style.width / 2)) ? (internalSystem.position.x - delegateHalfWidth)
    // :  xRightPos;

    const x = position.x < rightBorder / 2 ? internalSystem.position.x - delegateHalfWidth : xRightPos;

    const y = position.y + delegateHalfHieght > internalSystem.position.y + internalSystem.style.height ? internalSystem.position.y + internalSystem.style.height - delegateHalfHieght : position.y < internalSystem.position.y ? internalSystem.position.y : position.y;

    return {x, y};
};

export const clusterletPosition = (position, action) => {
    const clusterletWidth = 200;
    const clusterletHeight = 50;
    /** the commented code is to restrict the node inside the right border of internal system which was the requirement initially */

    // const x = position.x + internalSystem.position.x < internalSystem.position.x ? 0 :
    // 	position.x + internalSystem.position.x + clusterletWidth > internalSystem.position.x + internalSystem.style.width ? internalSystem.style.width - clusterletWidth :
    // 		position.x

    const x = position.x + internalSystem.position.x < internalSystem.position.x ? 0 : position.x > internalSystem.style.width ? internalSystem.position.x + internalSystem.style.width / 2 : position.x;

    const y = position.y + internalSystem.position.y < internalSystem.position.y ? 0 : position.y + internalSystem.position.y + clusterletHeight > internalSystem.position.y + internalSystem.style.height ? internalSystem.style.height - clusterletHeight : position.y;

    return {x, y};
};

export const sesnorUserPosition = (position, action, highestXVal) => {

    const sensorWidth = 100;
    const sensorHeight = 100;
    const offsetValue = 10;
    const additionalVerticalOffset = 0;

    let XValueLessThanRightBorder = position.x < xCordLeftMargin + internalSystem.style.width;
    let rightHorizontalDriftValue = internalSystem.position.x + internalSystem.style.width - position.x;

    let x = position.x;
    let y = position.y;

    if (highestXVal) {
        if (internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode > internalSystem.position.x + internalSystem.style.width) {
            XValueLessThanRightBorder = position.x < xCordLeftMargin + highestXVal + gapBtwRightBorderAndInternalNode;
            rightHorizontalDriftValue = internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode - position.x;
        }
    }

    /**check if inside bp*/
    if (
        position.x + sensorWidth > xCordLeftMargin &&
        // (position.x < xCordLeftMargin + internalSystem.style.width )) &&
        XValueLessThanRightBorder &&
        position.y + sensorHeight > yCordTopMargin &&
        position.y < yCordTopMargin + internalSystem.style.height
    ) {
        const topVerticalDrift = position.y + sensorHeight - internalSystem.position.y;
        const bottomVerticalDrift = internalSystem.position.y + internalSystem.style.height - position.y;
        const leftHorizontalDrift = position.x + sensorWidth - internalSystem.position.x;
        // const rightHorizontalDrift = internalSystem.position.x + internalSystem.style.width - position.x
        const rightHorizontalDrift = rightHorizontalDriftValue;

        const minValue = Math.min(topVerticalDrift, bottomVerticalDrift, leftHorizontalDrift, rightHorizontalDrift);

        if (minValue === topVerticalDrift) {
            y = position.y - topVerticalDrift - offsetValue + additionalVerticalOffset;
        } else if (minValue === bottomVerticalDrift) {
            y = position.y + bottomVerticalDrift + offsetValue + additionalVerticalOffset;
        } else if (minValue === leftHorizontalDrift) {
            x = position.x - leftHorizontalDrift - offsetValue;
        } else {
            x = position.x + rightHorizontalDrift + offsetValue;
        }
    }
    return {x, y};
};

export const findClusterletPositionsForImportedBp = (payload) => {
    const {clusterlets} = payload;

    let delegates = [];
    let digitalTwins = [];
    let analytics = [];
    let sensorsAndUsers = [];

    const clusterletsWithPositions = clusterlets.map((item) => {
        if (item.type === 1) {
            const newPos = generateDelegatePosition({delegates: delegates});
            const relativePos = findRelativePosition(newPos, item.type);
            item.position = relativePos;
            delegates.push(item);
        } else if (item.type === 2) {
            const newPos = generateDigitalTwinPosition({digitalTwins: digitalTwins});
            newPos.x = newPos.x - xCordLeftMargin;
            newPos.y = newPos.y - yCordTopMargin;
            const relativePos = findRelativePosition(newPos, item.type);
            item.position = relativePos;
            digitalTwins.push(item);
        } else if (item.type === 3) {
            const newPos = generateAnalyticsPosition({analytics: analytics});
            newPos.x = newPos.x - xCordLeftMargin;
            newPos.y = newPos.y - yCordTopMargin;
            const relativePos = findRelativePosition(newPos, item.type);
            item.position = relativePos;
            analytics.push(item);
        } else if (item.type === 4 || item.type === 20) {
            const newPos = generateSensorPosition({sensors: sensorsAndUsers});
            const relativePos = findRelativePosition(newPos, item.type);
            item.position = relativePos;
            sensorsAndUsers.push(item);
        }
        return item;
    });

    return clusterletsWithPositions;
};

export const findDelegateNodeAndConnections = ({clusterlets, edges, changedNode, highestXVal}) => {
    const rightBorder =
        highestXVal && internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode > internalSystem.position.x + internalSystem.style.width ? internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode : internalSystem.position.x + internalSystem.style.width;
    const rightBorderHalf = rightBorder / 2;

    const changedClusterlet = clusterlets.find((item) => item.id === changedNode.id);
    if (!externalSystemNodes.includes(changedClusterlet.type)) return {editConnections: [], delegatesToMoveLeft: [], delegatesToMoveRight: [], delegatesToMove: []};

    const connections = edges.filter((item) => item.source === changedNode.id || item.target === changedNode.id);

    let delegates = [];
    let swapConnections = [];
    let delegatesToMoveRight = [];
    let delegatesToMoveLeft = [];
    let delegatesToMove = [];
    const delegateHalfWidth = 60;
    let editConnections = [];

    connections.forEach((item) => {
        if (item.source === changedNode.id && clusterlets.find((e) => e.id === item.target).type === 'external_function') return delegates.push(clusterlets.find((e) => e.id === item.target));

        if (item.target === changedNode.id && clusterlets.find((e) => e.id === item.source).type === 'external_function') return delegates.push(clusterlets.find((e) => e.id === item.source));
    });

    delegates.forEach((item) => {
        const totalConnections = edges.filter((e) => e.source === item.id || e.target === item.id);
        swapConnections = totalConnections;

        if (totalConnections.length === 2 || totalConnections.length === 1) {
            if (item.position.x < rightBorderHalf && changedNode.position.x > rightBorderHalf) {

                delegatesToMoveRight.push(item);

                const xPosition = highestXVal ? internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode - delegateHalfWidth : internalSystem.position.x + internalSystem.style.width - delegateHalfWidth;

                let payload = {id: item.id, position: {x: xPosition, y: item.position.y}};

                delegatesToMove.push(payload);
            }

            if (item.position.x > /*internalSystem.position.x*/ rightBorderHalf && changedNode.position.x < rightBorderHalf) {

                delegatesToMoveLeft.push(item);

                let payload = {id: item.id, position: {x: internalSystem.position.x, y: item.position.y}};

                delegatesToMove.push(payload);
            }
        }
    });

    if (swapConnections.length === 2 && (delegatesToMoveRight.length > 0 || delegatesToMoveLeft.length > 0) && Object.values(swapConnections[0]).includes(changedNode.id)) {
        if (swapConnections[0].target === changedNode.id) {
            swapConnections[0].target = swapConnections[0].source;
            swapConnections[0].source = changedNode.id;
        }
    } else if (swapConnections.length === 2 && (delegatesToMoveRight.length > 0 || delegatesToMoveLeft.length > 0) && Object.values(swapConnections[1]).includes(changedNode.id)) {
        if (swapConnections[1].target === changedNode.id) {
            swapConnections[1].target = swapConnections[1].source;
            swapConnections[1].source = changedNode.id;
        }
    }

    if (delegatesToMoveRight.length > 0 && swapConnections.length <= 2) {
        editConnections = swapConnections.map((item) => {
            item.sourceHandle = 'left';
            item.targetHandle = 'right';
            return item;
        });
    }

    if (delegatesToMoveLeft.length > 0 && swapConnections.length <= 2) {
        editConnections = swapConnections.map((item) => {
            item.sourceHandle = 'right';
            item.targetHandle = 'left';
            return item;
        });
    }

    return {
        delegatesToMoveRight,
        delegatesToMoveLeft,
        editConnections,
        delegatesToMove,
    };
};

export const findExternalNodesAndConnections = ({clusterlets, edges, changedNode, highestXVal}) => {
    let externalNodes = [];
    let connections = [];
    let direction = 'noChange';
    let sensorRightPosX = internalSystem.position.x + internalSystem.style.width + gapBTWRightBorderAndExternalNode;
    let rightBorder = internalSystem.position.x + internalSystem.style.width;

    if (highestXVal) {
        if (internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode > internalSystem.position.x + internalSystem.style.width) {
            sensorRightPosX = internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode + gapBTWRightBorderAndExternalNode;
        }
        rightBorder = internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode;
    }

    if (clusterlets.find((item) => item.id === changedNode.id).type !== 1) return {externalNodes, direction, connections};

    const delegate = clusterlets.find((item) => item.id === changedNode.id);

    const delegateConnectedNodes = edges
        .filter((item) => item.source === changedNode.id || item.target === changedNode.id)
        .map((item) => {
            if (item.source === changedNode.id) return item.target;
            else return item.source;
        });

    const delegateConnectedExternalNodes = clusterlets
        .filter((item) => delegateConnectedNodes.includes(item.id))
        .filter((item) => externalSystemNodeTypes.includes(item.type))
        .filter((node) => edges.filter((item) => item.source === node.id || item.target === node.id).length === 1); //only if it is connected to the moved delegate

    direction =
        changedNode.position.x < /*internalSystem.position.x + (internalSystem.style.width/2)*/ rightBorder / 2 && delegate.position.x > /*internalSystem.position.x*/ rightBorder / 2
            ? 'left'
            : changedNode.position.x > /*internalSystem.position.x*/ rightBorder / 2 && delegate.position.x < /*internalSystem.position.x */ rightBorder / 2
            ? 'right'
            : 'noChange';

    const sensorAndUserNodes = clusterlets
        .filter((item) => delegateConnectedNodes.includes(item.id))
        .filter((item) => externalSystemNodeTypes.includes(item.type))
        .map((item) => item.id);
    const clusterletsAndAnalytics = clusterlets
        .filter((item) => delegateConnectedNodes.includes(item.id))
        .filter((item) => internalSystemNodesTypes.includes(item.type))
        .map((item) => item.id);

    const swapConnections = edges
        .filter((item) => item.source === changedNode.id || item.target === changedNode.id)
        .map((item) => {
            if (item.target !== changedNode.id && sensorAndUserNodes.includes(item.target)) return {...item, source: item.target, target: changedNode.id};
            if (clusterletsAndAnalytics.includes(item.target) || clusterletsAndAnalytics.includes(item.source)) return {...item, source: clusterletsAndAnalytics.includes(item.target) ? changedNode.id : item.source, target: clusterletsAndAnalytics.includes(item.target) ? item.target : item.source};
            else return item;
        });

    if (direction === 'left') {
        externalNodes = delegateConnectedExternalNodes.map((item) => {
            let payload = {id: item.id, position: {x: internalSystem.position.x - gapBTWLeftBorderAndExternalNode, y: item.position.y}};
            return payload;
        });

        connections = swapConnections.map((item) => {
            return {...item, sourceHandle: 'right', targetHandle: 'left'};
        });
    }

    if (direction === 'right') {
        externalNodes = delegateConnectedExternalNodes.map((item) => {
            let payload = {id: item.id, position: {x: sensorRightPosX, y: item.position.y}};
            return payload;
        });

        connections = swapConnections.map((item) => {
            return {...item, sourceHandle: 'left', targetHandle: 'right'};
        });
    }


    return {
        externalNodes,
        direction,
        connections,
    };
};

export const findExternalNodesToBeMovedWhenInternalNodesAreMoved = ({internalNodesWithAbsPosition, externalNodesWithAbsPosition, changedNode, highestXVal, highestXValueBeforeChangeInPosition}) => {
    const clusterlets = internalNodesWithAbsPosition.map((item) => {
        item.position = item.absolutePosition;
        delete item.absolutePosition;
        return item;
    });

    const externalNodes = externalNodesWithAbsPosition.map((item) => {
        item.position = item.absolutePosition;
        delete item.absolutePosition;
        return item;
    });

    const originalNode = clusterlets.find((item) => item._id === changedNode.id);
    const nodeOrginialPos = clusterlets.find((item) => item._id === changedNode.id)?.position?.x;
    let externalNodesToMoveRight = [];
    let externalNodesToMoveLeft = [];
    let difference = Math.abs(highestXValueBeforeChangeInPosition - highestXVal);

    const rightBorder = highestXVal ? internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode : internalSystem.position.x + internalSystem.style.width;

    //if movement inside the internal system, no change for external nodes, return
    if (internalSystem.position.x + changedNode.position.x + gapBtwRightBorderAndInternalNode < internalSystem.position.x + internalSystem.style.width && internalSystem.position.x + nodeOrginialPos < internalSystem.position.x + internalSystem.style.width) {

        return {externalNodesToMoveLeft, externalNodesToMoveRight};
    }

    //check if moved to right
    if (nodeOrginialPos < changedNode.position.x && highestXVal && internalSystemNodesTypes.includes(originalNode.type)) {

        if (internalSystem.position.x + highestXVal + gapBtwRightBorderAndInternalNode > internalSystem.position.x + internalSystem.style.width) {

            externalNodesToMoveRight = externalNodes.filter((item) => externalSystemNodeTypes.includes(item.type) && item.position.x > rightBorder);

            externalNodesToMoveRight.forEach((item) => {
                item.position.x = item.position.x + difference;
            });
        }
    }

    //check if moved to left
    if (nodeOrginialPos > changedNode.position.x && highestXVal && internalSystemNodesTypes.includes(originalNode.type)) {

        externalNodesToMoveLeft = externalNodes.filter((item) => externalSystemNodeTypes.includes(item.type) && item.position.x > rightBorder);


        externalNodesToMoveLeft.forEach((item) => {
            if (item.position.x - difference < internalSystem.position.x + internalSystem.style.width) {
                item.position.x = internalSystem.position.x + internalSystem.style.width + gapBTWRightBorderAndExternalNode;
            } else item.position.x = item.position.x - difference;
        });
    }

    // console.log("findExternalNodesToBeMovedWhenInternalNodesAreMoved", { externalNodes ,rightBorder, clusterlets, changedNode, originalNode, internalSystem, externalNodesToMoveRight, externalNodesToMoveLeft, highestXVal, highestXValueBeforeChangeInPosition, difference, internalNodesWithAbsPosition, externalNodesWithAbsPosition })

    return {
        externalNodesToMoveRight,
        externalNodesToMoveLeft,
    };
};

export const findInternalSystemWidth = (rfNodes) => {
    const elementsWithAbsoluePosition = JSON.parse(JSON.stringify(rfNodes));
    const xValues = elementsWithAbsoluePosition.filter((item) => internalSystemNodes.includes(item.type)).map((item) => item.position.x);
    const highestXVal = Math.max(...xValues);
    const internalSystem1 = JSON.parse(JSON.stringify(internalSystem));

    let width = internalSystem1.style.width;

    if (highestXVal && highestXVal > 0) {
        if (internalSystem1.position.x + highestXVal + gapBtwRightBorderAndInternalNode > internalSystem1.position.x + internalSystem1.style.width) {
            width = highestXVal + gapBtwRightBorderAndInternalNode;
            // return item
        }

        if (internalSystem1.position.x + highestXVal + gapBtwRightBorderAndInternalNode < internalSystem1.position.x + internalSystem1.style.width) {
            width = internalSystem1.style.width;
            // return item
        }
    }


    return width;
};
